import { RootState } from "@redux/store"
import { checkOrganizationSubscription } from "@services/finance/finance-services"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

/**
 * Hook to check if the currently organization fot the logged user has a subscription 
 * and a coupon tied to its owner.
 */
const useOrganizationSubscriptionAccess = () => {
    const [ organizationSubscription, setOrganizationSub ] = useState<boolean>(false)
    const [ couponSubscription, setCouponSub ] = useState<boolean>(false)
    const [ error, setError ] = useState<unknown | null>(null)
    const [ hasLoaded, setHasLoaded ] = useState<boolean>(false)

    const { organization } = useSelector((state: RootState) => ({ organization: state.organizations }));

    useEffect(() => {
        if(!organization) return
        setHasLoaded(false)
        checkOrganizationSubscription(organization.organizationId)
            .then((result) => {
                setOrganizationSub((result.type === "SUB" && !organization.predeterminedDrProx))
                setCouponSub(result.type === "CUP")
            })
            .catch(err => {
                console.error("useOrganizationSubscriptionAccess - checkOrganizationSubscription", err)
                setError(err)
            })
            .finally(() => setHasLoaded(true))
    }, [organization])

    return { organizationSubscription, couponSubscription, error, hasLoaded }
}

export default useOrganizationSubscriptionAccess
